import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2, CheckCircle } from "lucide-react";
import "./MobileFirstProcessingStep.scss";

export default function MobileFirstProcessingStep({ 
  loading = true,
  step = "excel" // "excel" o "single"
}) {
  const { t } = useTranslation();
  const getSteps = () => {
    if (step === "excel") {
      return [
        { id: "validating", label: "Validando datos", completed: true },
        { id: "creating", label: "Creando paquetes", active: true }
      ];
    } else {
      return [
        { id: "validating", label: "Validando datos", completed: true },
        { id: "creating", label: "Creando paquete", active: true }
      ];
    }
  };

  const steps = getSteps();

  return (
    <div className="mobile-processing">
      <div className="mobile-processing__container">
        {/* Header simple con spinner y título */}
        <div className="mobile-processing__header">
          <div className="mobile-processing__spinner">
            <Loader2 size={32} className="spinner-icon" />
          </div>
          <div className="mobile-processing__title">
            <h4>
              {step === "excel" ? t("Procesando archivo Excel...") : t("Creando tu paquete...")}
            </h4>
            <p>{t("Por favor espera, esto puede tomar unos momentos")}</p>
          </div>
        </div>

        {/* Lista de pasos simplificada */}
        <div className="mobile-processing__steps">
          {steps.map((stepItem) => (
            <div 
              key={stepItem.id}
              className={`mobile-processing__step ${
                stepItem.completed ? 'completed' : 
                stepItem.active ? 'active' : ''
              }`}
            >
              <div className="mobile-processing__step-icon">
                {stepItem.completed ? (
                  <CheckCircle size={18} className="step-icon-check" />
                ) : stepItem.active ? (
                  <Loader2 size={18} className="step-icon-spinner" />
                ) : null}
              </div>
              
              <div className="mobile-processing__step-content">
                <span className="mobile-processing__step-label">
                  {t(stepItem.label)}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
